// extracted by mini-css-extract-plugin
var _1 = "_productSettingCreateProductForm-module__container";
var _2 = "_productSettingCreateProductForm-module__edit-button";
var _3 = "_productSettingCreateProductForm-module__flex-div";
var _4 = "_productSettingCreateProductForm-module__flex-span-container";
var _5 = "_productSettingCreateProductForm-module__form-container";
var _6 = "_productSettingCreateProductForm-module__form-subcontainer";
var _7 = "_productSettingCreateProductForm-module__round";
var _8 = "_productSettingCreateProductForm-module__slider";
var _9 = "_productSettingCreateProductForm-module__submit-button";
var _a = "_productSettingCreateProductForm-module__switch";
export { _1 as "container", _2 as "edit-button", _3 as "flex-div", _4 as "flex-span-container", _5 as "form-container", _6 as "form-subcontainer", _7 as "round", _8 as "slider", _9 as "submit-button", _a as "switch" }
